import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Table } from '../../../../../common/ui';
import styles from '../styles.module.css';
import ReturnChips from '../../../supplierReturn/components/ReturnChips';
import { AppliedChip, ReplacementChip } from '../../../supplierReturn/components/ReplacementLink';
import { fetchInvoiceStocks, fetchPostedReturnsForSource } from '../../../supplierReturn/actions';

const ViewInvoice = ({
  fetchInvoiceStocks,
  fetchPostedReturnsForSource,
  auth: { branchId },
}) => {
  const { id } = useParams();
  const [lines, setLines] = useState([]);
  const [chips, setChips] = useState([]);

  useEffect(() => {
    let cancelled = false;
    setLines([]);
    setChips([]);
    async function load() {
      const stockRows = await fetchInvoiceStocks(id);
      const chipRows = await fetchPostedReturnsForSource('supplier_invoice', id);
      if (!cancelled) {
        setLines(Array.isArray(stockRows) ? stockRows : []);
        setChips(Array.isArray(chipRows) ? chipRows : []);
      }
    }
    if (id) load();
    return () => {
      cancelled = true;
    };
  }, [id, branchId, fetchInvoiceStocks, fetchPostedReturnsForSource]);

  const rows = (lines || []).map((line) => ({
    ...line,
    chips: (chips || []).filter(
      (chip) => String(chip.sourceLineId) === String(line.id)
    ),
  }));

  const columns = [
    { id: 'productName', label: 'Product', minWidth: 160 },
    { id: 'qty', label: 'Quantity', minWidth: 100 },
    {
      id: 'chips',
      label: 'Returns',
      minWidth: 180,
      render: (value) => <ReturnChips chips={value} />,
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleSection}>
          <h1 className={styles.pageTitle}>Invoice</h1>
          <p className={styles.breadcrumb}>Inventory / Invoices</p>
        </div>
      </div>
      <div className={styles.body}>
        <ReplacementChip
          id={lines[0]?.relatedSupplierReturnId}
          returnNo={lines[0]?.replacementReturnNo}
        />
        {(Array.isArray(lines[0]?.appliedSupplierReturns) ? lines[0].appliedSupplierReturns : []).map((row) => (
          <AppliedChip key={row.id} id={row.id} returnNo={row.returnNo} />
        ))}
        <div className={styles.chartMainDiv}>
          <Table columns={columns} rows={rows} emptyMessage="No invoice lines." />
        </div>
      </div>
    </div>
  );
};

ViewInvoice.propTypes = {
  fetchInvoiceStocks: PropTypes.func.isRequired,
  fetchPostedReturnsForSource: PropTypes.func.isRequired,
  auth: PropTypes.shape({
    branchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.authState,
});

export default connect(mapStateToProps, {
  fetchInvoiceStocks,
  fetchPostedReturnsForSource,
})(ViewInvoice);
